import { Badge } from "./Badge";

/**
 * Consistent "this needs backend work" marker for sections built ahead of
 * their endpoint (mirrors the GAP-comment convention used throughout
 * web/mobile's service files, surfaced visually here since admins are
 * looking at a live dashboard, not reading source).
 */
export function GapNotice({ children }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: "var(--space-2)", padding: "var(--space-3)", background: "var(--color-bg-subtle)", borderRadius: "var(--radius-md)" }}>
      <Badge tone="warning">Not Yet Wired</Badge>
      <span style={{ color: "var(--color-text-muted)", fontSize: "var(--font-size-sm)" }}>{children}</span>
    </div>
  );
}
